import { render, staticRenderFns } from "./settled.vue?vue&type=template&id=b9b3824c&scoped=true&"
import script from "./settled.vue?vue&type=script&lang=js&"
export * from "./settled.vue?vue&type=script&lang=js&"
import style0 from "./settled.vue?vue&type=style&index=0&id=b9b3824c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b3824c",
  null
  
)

export default component.exports